import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { ThemeProvider } from "@/components/ThemeProvider";
import { prefetchHomepageBootstrap } from "@/utils/publicBootstrap";


// Suppress noisy Chromium ResizeObserver loop errors that are harmless but clutter logs
if (typeof window !== 'undefined') {
  // 1) Patch ResizeObserver to defer callbacks to next frame to avoid loop limit exceeded
  if (window.ResizeObserver) {
    const OriginalRO = window.ResizeObserver;
    window.ResizeObserver = class PatchedResizeObserver extends OriginalRO {
      constructor(callback) {
        super((entries, observer) => {
          // Defer to next frame to prevent resize loops
          requestAnimationFrame(() => {
            try { callback(entries, observer); } catch (err) {
              // swallow to avoid noisy console
            }
          });
        });
      }
    };
  }

  // 2) Stop propagation of specific browser-level errors
  const ignoreResizeObserverError = (event) => {
    const msg = event?.message || event?.reason?.message;
    if (typeof msg === 'string' && (
      msg.includes('ResizeObserver loop limit exceeded') ||
      msg.includes('ResizeObserver loop completed with undelivered notifications')
    )) {
      if (event.preventDefault) event.preventDefault();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      return false;
    }
    return undefined;
  };
  window.addEventListener('error', ignoreResizeObserverError, true);
  window.addEventListener('unhandledrejection', ignoreResizeObserverError, true);

  // 3) Silence console.error and console.warn lines for the known ResizeObserver messages
  const originalConsoleError = console.error;
  const originalConsoleWarn = console.warn;
  const swallow = (first) => typeof first === 'string' && (
    first.includes('ResizeObserver loop limit exceeded') ||
    first.includes('ResizeObserver loop completed with undelivered notifications')
  );
  console.error = (...args) => {
    try { if (swallow(args?.[0])) return; } catch {}
    return originalConsoleError.apply(console, args);
  };
  console.warn = (...args) => {
    try { if (swallow(args?.[0])) return; } catch {}
    return originalConsoleWarn.apply(console, args);
  };
}

prefetchHomepageBootstrap();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // Temporarily disabled React.StrictMode due to react-beautiful-dnd compatibility issues
  // React Strict Mode causes double-rendering which interferes with drag-and-drop library's DOM tracking
  // <React.StrictMode>
    <ThemeProvider defaultTheme="light" storageKey="ndis-ui-theme">
      <App />
    </ThemeProvider>
  // </React.StrictMode>
);
